import { AdvertisementsData, AdvertisementsSponsorItem } from "@/types/ads";
import { api } from "@/utils/util";
import { useQuery } from "react-query";

export const useAdvertisementsSponsor = (advertisement: string) => {
  return useQuery<AdvertisementsSponsorItem[]>({
    queryKey: ["advertisementsSponsor", advertisement],
    queryFn: () =>
      api.get(`/advertisements/sponsor?advertisementType=${advertisement}`).then((res) => res.data),
    enabled: !!advertisement,
    onError: (e: any) => e?.response?.data?.msg && alert(e.response.data.msg),
  });
};

// /advertisements/:adsid
export const useSdvertisements = (adsid: string) => {
  return useQuery<AdvertisementsData>({
    queryKey: ["advertisements", adsid],
    queryFn: () => api.get(`/advertisements/${adsid}`).then((res) => res.data[0]),
    enabled: !!adsid,
    onError: (e: any) => e?.response?.data?.msg && alert(e.response.data.msg),
  });
};
